/**
 * Copyright (c) 2018， Silicon Valley Career Women.
 * All rights reserved.
 */
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import * as React from 'react';

import ActivateEmail from '../pages/activate-email';
import Dashboard from '../pages/dashboard';
import ForgetPassword from '../pages/forget-password';
import Landing from '../pages/landing';
import Profile from '../pages/profile';
import ResetPassword from '../pages/reset-password';
import SignIn from '../pages/sign-in';
import SignOut from '../pages/sign-out';
import SignUp from '../pages/sign-up';
import UserInfo from '../pages/user-info';

export default () => (
  <Router>
    <Switch>
      <Route path="/" exact={true} component={Landing} />
      <Route path="/activate/uid/:uid/token/:token" component={ActivateEmail} />
      <Route path="/dashboard" component={Dashboard} />
      <Route path="/forget-password" component={ForgetPassword} />
      <Route path="/profile" component={Profile} />
      <Route path="/reset-password/uid/:uid/token/:token" component={ResetPassword} />
      <Route path="/sign-in" component={SignIn} />
      <Route path="/sign-out" component={SignOut} />
      <Route path="/sign-up/:userType?" component={SignUp} />
      <Route path="/user-info/:userType?" component={UserInfo} />
    </Switch>
  </Router>
);



// WEBPACK FOOTER //
// ./src/routers/index.tsx